import React from "react";
import { useTranslation } from "react-i18next";
import { IconButton, Tooltip } from "@mui/material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { useAppSelector } from "../../hooks";
import { useRouter } from "../../hooks/useRouter";
import { ROUTES } from "../../routes";
import { useWhiteboardRoom } from "../../hooks/useWhiteboardRoom";
import { createClickEngagementRecorder } from "../../utils/api";
import { useLocation } from 'react-router-dom';

const BtoCMessage = () => {
  const location_route = useLocation();
  const { t } = useTranslation();
  const { push, location } = useRouter();
  const { lastBToCTarget } = useAppSelector((state) => state.bToCState);
  const { roomDomain, notitficationUnreadCount } = useWhiteboardRoom();
  const clickRecorder = createClickEngagementRecorder(roomDomain, roomDomain);
  const handleBtnClick = () => {
    clickRecorder("bToC");
    push({
      pathname: `${ROUTES.B_TO_C_PAGE}/${
        (lastBToCTarget?.toDomain && lastBToCTarget.toDomain) || roomDomain
      }`
    }, location_route.search);
  };

  const isActive =
    location.pathname.includes(ROUTES.B_TO_C_PAGE) ||
    location.state?.from?.includes(ROUTES.B_TO_C_PAGE);

  return (
    <Tooltip
      title={t("Loyal_Chat")}
      placement="bottom"
      arrow
      disableInteractive
    >
      <IconButton
        aria-label="support"
        onClick={handleBtnClick}
        sx={{
          color: isActive ? "#3396FF" : "#FFFFFF",
          position: "relative",
          padding: "5px",
          '&:hover': {backgroundColor: 'transparent'}}}
      >
        <SupportAgentIcon fontSize="small" />
        {notitficationUnreadCount > 0 && (
          <span
            style={{
              position: "absolute",
              bottom: 3,
              right: 3,
              fontSize: "10px",
              color: "#FFFFFF",
              background: "#1f8feb",
              borderRadius: "7px",
              padding: "1px 4px",
            }}
          >
            {notitficationUnreadCount}
          </span>
        )}
      </IconButton>
    </Tooltip>
  );
};

export default BtoCMessage;
